import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SelectList } from 'react-widgets';
import ArrayUtil from '../../../../../utils/ArrayUtil';

const getSelectedAbilities = (competency, selected) => {
  const comSelected = [];
  if (ArrayUtil.isNotEmpty(selected) && ArrayUtil.isNotEmpty(competency.abilities)) {
    selected.forEach((sel) => {
      const item = competency.abilities.find(ab => ab.id === sel);
      if (item) {
        comSelected.push(item);
      }
    });
  }
  return comSelected;
};

const generateCompetencyGroupNoForm = (groups, options = {}, selected = []) => {
  const compGroupList = groups.map((group, i) => {
    const dimList = group.map((comp, j) => {
      const selectedAbilities = getSelectedAbilities(comp, selected);

      return ArrayUtil.isNotEmpty(selectedAbilities) ? (
        // eslint-disable-next-line react/no-array-index-key
        <div key={j}>
          <div>
            <label className="field-label">{comp.displayName}</label>
          </div>
          <SelectList
            {...options}
            textField="displayName"
            valueField="id"
            defaultValue={selected}
            multiple
            data={selectedAbilities}
          />
        </div>
      ) : null;
    });
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={i} className="mt10">
        {dimList}
      </div>
    );
  });

  return compGroupList;
};

const SectionCompetencies = (props) => {
  const { competencies, selected } = props;

  const competencyGroups = ArrayUtil.chunk(competencies, 2);
  const options = {
    readOnly: true,
    disabled: true,
  };
  return (
    <div>
      <h3 className="section-title">
        <FormattedMessage id="attrs.competencies" defaultMessage="Competencies" />
      </h3>
      <div className="dimension-section">{generateCompetencyGroupNoForm(competencyGroups, options, selected)}</div>
    </div>
  );
};

SectionCompetencies.propTypes = {
  competencies: PropTypes.arrayOf(PropTypes.any).isRequired,
  selected: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default SectionCompetencies;
